module.exports = __webpack_public_path__ + "img/yejin.97a360dc.jpg";